import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type FacetCounts = {
  method: Record<string, number>;
  diet: Record<string, number>;
  holiday: Record<string, number>;
  category: Record<string, number>;
};

export const useRecipeFacetCounts = () => {
  return useQuery({
    queryKey: ["recipe-facet-counts"],
    staleTime: 60 * 60 * 1000,
    gcTime: 2 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    queryFn: async (): Promise<FacetCounts> => {
      const { data } = await supabase
        .from("recipes")
        .select("category, method, diet, holiday")
        .eq("is_published", true);
      const out: FacetCounts = { method: {}, diet: {}, holiday: {}, category: {} };
      (data ?? []).forEach((r: any) => {
        if (r.category) out.category[r.category] = (out.category[r.category] ?? 0) + 1;
        (r.method ?? []).forEach((v: string) => { out.method[v] = (out.method[v] ?? 0) + 1; });
        (r.diet ?? []).forEach((v: string) => { out.diet[v] = (out.diet[v] ?? 0) + 1; });
        (r.holiday ?? []).forEach((v: string) => { out.holiday[v] = (out.holiday[v] ?? 0) + 1; });
      });
      return out;
    },
  });
};